'use client';
import React from "react"
import type { RootState } from '@/lib/redux-toolkit/store';
import { useSelector } from 'react-redux';
import "@/resources/css/loading.css";
const Loading = () => {
    const setting = useSelector((state: RootState) => state.setting.value);
    let classLoading = 'cssload-background';
    if(!setting.loading){
        classLoading = classLoading + " display-hidden";
    }
    return (
        <div id="cssload-loader-main" className={classLoading} >
            <div className="cssload-loader-background"></div>
            <div id="cssload-loader-content" className="cssload-loader">
                <div className="cssload-side"></div>
                <div className="cssload-side"></div>
                <div className="cssload-side"></div>
                <div className="cssload-side"></div>
                <div className="cssload-side"></div>
                <div className="cssload-side"></div>
                <div className="cssload-side"></div>
                <div className="cssload-side"></div>
            </div>
        </div>
    )
}
export default Loading